module.exports = __webpack_public_path__ + "img/detail.adfdfbe3.png";